import { Carousel, CarouselContent, CarouselNext, CarouselPrevious } from 'components/ui/carousel';
import type { CarouselItem, CarouselApi } from 'components/ui/carousel';

/* 
  Note: This component is coupled to Products/Benefits pages.
    - In order to make it full bleed in x-axis, margins were added to compensate the negative ones in the parent container (in section components). 
    - If you need to use this component in other pages, maybe you'll want to undo its full bleeding by removing the margins -- or figure a better approach.
*/
export const CardsCarousel = ({
  children,
  count,
  current,
  api,
  setApi,
}: {
  children: React.ReactElement<typeof CarouselItem>[];
  count: number;
  current: number;
  api: CarouselApi;
  setApi: (api: CarouselApi) => void;
}) => (
  <Carousel
    className="flex w-full flex-col gap-10"
    setApi={setApi}
    opts={{
      align: 'start',
      loop: false,
    }}
  >
    <CarouselContent className="relative inset-x-1/2 mx-[-50vw] w-screen">{children}</CarouselContent>
    <div className="mx-4 flex flex-row justify-between md:mx-10">
      <div className="mt-4 flex flex-row items-start space-x-0">
        <CarouselPrevious className="static flex size-9 items-center justify-center rounded-r-none border-none bg-[#262626] text-white hover:bg-[#3f3f3f] disabled:opacity-50" />
        <CarouselNext className="static flex size-9 items-center justify-center rounded-l-none  border-none bg-[#262626] text-white hover:bg-[#3f3f3f] disabled:opacity-50" />
      </div>
      <div className="flex items-center justify-center space-x-2 py-2">
        {Array.from({ length: count }).map((_, index) => (
          <button
            type="button"
            key={index}
            onClick={() => api?.scrollTo(index)}
            className={`size-2 rounded-full ${index === current ? 'bg-gold-100' : 'bg-[#404040]'}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  </Carousel>
);
